import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'fspro-playback-error',
  templateUrl: './playback-error.component.html',
  styleUrls: ['./playback-error.component.scss'],
  standalone: false,
})
export class PlaybackErrorComponent {
  get contactUs(): string {
    return `<a href="mailto:feedback@festivalscope.com">${this.translateService.instant('fspro.front.error.playback.message_contact_us')}</a>`;
  }

  constructor(private readonly translateService: TranslateService) {
  }
}
